<div class="license-agreement-container">
  <div class="license-agreement-left"></div>
  <div class="license-agreement-right">
    <div class="eula-panel">
      <h4>End User License Agreement</h4>
      <p>Please read and accept the terms below to continue.</p>
      <iframe
        #eulaFrame
        src="assets/eula/DNA EULA (August 2026) c36642a6.html"
        title="End User License Agreement"
        class="eula-frame"
        (load)="onFrameLoad()"
      ></iframe>
      <div class="accept-btn">
        <app-button class="flow-cta" [fullWidth]="true" [disabled]="!eulaRead" (click)="handleAccept()">
          <span i18n>Accept</span>
        </app-button>
      </div>
    </div>
  </div>
</div>
